import { ButtonBase, Typography, useTheme } from "@mui/material";
import { ChevronLeft } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	color: string;
	onClick: () => void;
};

export const HeaderBackLabelButton: FC<Props> = ({ label, color, onClick }) => {
	const { iconSize, spacingTokens } = useTheme();

	return (
		<ButtonBase
			disableRipple
			onClick={onClick}
			sx={{ gap: spacingTokens.xs, color }}
		>
			<ChevronLeft size={iconSize.md} />
			<Typography variant="bodyMedium" color="inherit">
				{label}
			</Typography>
		</ButtonBase>
	);
};
